<template>
  <div>
    <pcg-btn size="small" @click="updateWebpage(false)" class="action-btn mr-3">{{ $t('views.webpages.webpages_edit.save') }}</pcg-btn>
    <pcg-btn size="small" @click="updateWebpage(false, true)" class="action-btn mr-3">{{ $t('views.webpages.webpages_edit.save_and_publish') }}</pcg-btn>
    <pcg-btn v-show="form.status === 'draft'" size="small" @click="updateWebpage(true)" variant="additional" class="action-btn">{{ $t('views.webpages.webpages_edit.save_as_draft') }}</pcg-btn>
    <abk-new-page-form class="form" v-model="form" :loading="loading" :submitted="submitted" :errors="errors"/>
    <pcg-btn size="small" @click="updateWebpage(false)" class="action-btn mr-3">{{ $t('views.webpages.webpages_edit.save') }}</pcg-btn>
    <pcg-btn size="small" @click="updateWebpage(false, true)" class="action-btn mr-3">{{ $t('views.webpages.webpages_edit.save_and_publish') }}</pcg-btn>
    <pcg-btn v-show="form.status === 'draft'" size="small" @click="updateWebpage(true)" variant="additional" class="action-btn">{{ $t('views.webpages.webpages_edit.save_as_draft') }}</pcg-btn>
  </div>
</template>

<script>
import AbkNewPageForm from '../../components/AbkNewPageForm'
import ApiWebpages from '../../api/webpages'

export default {
  name: 'WebpagesEdit',
  components: { AbkNewPageForm },
  data () {
    return {
      id: this.$route.params.id,
      errors: {},
      loading: false,
      submitted: false,
      form: {
        roles: [],
        navigation: null,
        address: null,
        title: null,
        content: null,
        parentId: null,
        sort: null,
        metaDescription: null,
        keywords: null,
        attachment: null,
        status: null,
        forum: null,
        webpageAttachments: [],
        language: null
      }
    }
  },
  mounted () {
    this.getWebpage()
  },
  methods: {
    setHeader () {
      this.$store.dispatch('header/setHeader', {
        title: this.$t('views.webpages.webpages_edit.title'),
        subtitle: this.$t('views.webpages.webpages_edit.subtitle')
      })
    },
    getWebpage () {
      ApiWebpages.getWebpage(this.id)
        .then(response => {
          this.form = response.data.data.attributes
          let key = 0
          this.form.webpageAttachments = response.data.included.map((webpageAttachment) => {
            return {
              id: webpageAttachment.id,
              key: key++,
              ...webpageAttachment.attributes
            }
          })
          this.$store.dispatch('header/setObjectName', this.form.title)
        }).catch(error => {
          console.log(error)
        })
    },
    updateWebpage (draft, published = false) {
      this.loading = true
      this.submitted = false
      let webpage
      if (draft) {
        webpage = { ...this.form, status: 'draft' }
      } else if (published) {
        webpage = { ...this.form, status: 'published' }
      } else {
        webpage = { ...this.form }
      }

      ApiWebpages.updateWebpage(this.id, { webpage: webpage })
        .then(response => {
          this.errors = {}
          this.getWebpage()
          setTimeout(() => { this.$toastr.s(this.$t('views.webpages.webpages_edit.webpage_updated')) }, 1)
          // this.$router.push({ name: 'webpages_path' })
        }).catch(error => {
          this.errors = error.response.data
          setTimeout(() => { this.$toastr.e(this.$t('general.check_errors')) }, 1)
        }).finally(() => {
          this.loading = false
          this.submitted = true
        })
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.setHeader()
    })
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/stylesheets/vars";

  .action-btn {
    padding-left: 0;
    padding-right: 0;
    width: 150px;
    margin: 0;
  }
  .form {
    margin-top: $pcg-m-xxl;
  }
</style>
